/**
 * The container's identity chip — solid color, white text, truncates at
 * realistic name lengths so a 40-char name never breaks the board grid.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { RadioTower } from 'lucide-react';

interface Props {
  name: string;
  color: string;
  className?: string;
  /** A route-test container wears the radio mast, so it reads apart from the others. */
  routeTest?: boolean;
}

export const ContainerChip: FC<Props> = ({ name, color, className, routeTest = false }) => (
  <span
    title={routeTest ? `${name} · route test` : name}
    className={`inline-flex max-w-full items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold text-white ${className ?? ''}`}
    style={{ backgroundColor: color }}
  >
    {routeTest ? <RadioTower className="h-3 w-3 shrink-0" aria-label="Route test" /> : null}
    <span className="min-w-0 truncate">{name}</span>
  </span>
);
